<template>
  <v-dialog scrollable class="dialog" v-model="config.status.active">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat class="grey lighten-3 blue-grey--text text--darken-4">
          <v-toolbar-title class="headline">{{ isTypeInsert ? '新規申込の追加' : (isTypeUpdate ? '申込み内容の編集' : '')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-title>
      <v-card-text v-if="config.status.active">
        <v-form ref="form" lazy-validation v-model="form.valid">
          <MainForm ref="mainForm" :status="getStatus" @emit="emitted" />
          <ArrangementsForm ref="arrangementsForm" />
        </v-form>
      </v-card-text>
      <v-card-actions class="grey lighten-3">
        <v-btn flat class="blue--text text--darken-2" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed class="blue darken-2 white--text"
          :loading="isLoading"
          :disabled="!isValid" @click.stop="submit">{{ isTypeInsert ? '追加する' : (isTypeUpdate ? '保存する' : '') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MainForm from '../../forms/main'
import ArrangementsForm from '../../forms/arrangements'
const DEF = {
  TYPE: 'insert',
  PAGE: 'main'
}
export default {
  name: 'ProgramModal',
  components: {
    MainForm,
    ArrangementsForm
  },
  props: [
    'item'
  ],
  data () {
    return {
      config: {
        type: '',
        status: {
          active: false,
          loading: false
        },
        page: DEF.PAGE
      },
      meta: {
      },
      form: {
        valid: true
      }
    }
  },
  methods: {
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    validate: function (status) {
      if (status == null) {
        this.$refs.form.validate()
      } else {
        this.$set(this.form, 'valid', status)
      }
    },
    submit: function () {
      const mfm = this.$refs.mainForm.getForm()
      const afm = this.$refs.arrangementsForm.getForm()
      if (this.$refs.form.validate() && Object.keys(mfm).length && Object.keys(afm).length) {
        this.$set(this.config.status, 'loading', true)
        this.axios.post(`${this.$url.api}user/apply/${this.config.type}/item`, {
          form: Object.assign({}, mfm, { arrangements: afm })
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
          if (res.data && res.data.success) {
            this.$emit('done', res.data.data)
            this.close()
          }
        })
      }
    },
    open: function (req) {
      this.$set(this.config.status, 'active', true)
      this.$set(this.form, 'valid', true)
      if (req) {
        const { type } = req || DEF.TYPE
        this.$set(this.config, 'type', type)
        if (type === 'update' && this.$props.item) {
          this.$nextTick(() => {
            const { arrangements } = this.$props.item
            this.$refs.mainForm.init({ values: this.$props.item })
            this.$refs.arrangementsForm.init({ values: arrangements })
          })
        }
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isTypeInsert () {
      return this.config.type === 'insert'
    },
    isTypeUpdate () {
      return this.config.type === 'update'
    },
    isPageMain () {
      return this.config.page === 'main'
    },
    isPageReader () {
      return this.config.page === 'reader'
    },
    isPageConfirm () {
      return this.config.page === 'confirm'
    },
    isLoading () {
      return this.config.status.loading !== false
    },
    printLoading () {
      return Number.isFinite(this.config.status.loading) ? this.config.status.loading : 0
    },
    getStatus () {
      return this.config.status
    },
    getFlightStatusItems () {
      return Object.keys(this.$meta.apply.flight.status).map(key => {
        return {
          text: this.$meta.apply.flight.status[key],
          value: key
        }
      })
    },
    getInsuranceStatusItems () {
      return Object.keys(this.$meta.apply.insurance.status).map(key => {
        return {
          text: this.$meta.apply.insurance.status[key],
          value: key
        }
      })
    },
    getVisaStatusItems () {
      return Object.keys(this.$meta.apply.visa.status).map(key => {
        return {
          text: this.$meta.apply.visa.status[key],
          value: key
        }
      })
    },
    getVisaTypeItems () {
      return Object.keys(this.$meta.visa.types).map(key => {
        return {
          value: key,
          text: this.$meta.visa.types[key]
        }
      })
    },
    getPickupStatusItems () {
      return Object.keys(this.$meta.apply.pickup.status).map(key => {
        return {
          text: this.$meta.apply.pickup.status[key],
          value: key
        }
      })
    },
    getPickupTypeItems () {
      return this.$meta.apply.pickup.type
    }
  }
}
</script>
